import axios from 'axios';
import useAuthStore from '../store/authStore';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:4000/api',
  withCredentials: true,
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      useAuthStore.getState().clearUser();
    }
    return Promise.reject(error);
  }
);

// Get all shorts with pagination
export const getShorts = async (page = 1, limit = 10) => {
  const response = await api.get('/shorts', {
    params: { page, limit }
  });
  return response.data;
};

// Get a single short by ID or slug
export const getShortById = async (shortId) => {
  const response = await api.get(`/shorts/${shortId}`);
  return response.data;
};

// Get featured shorts
export const getFeaturedShorts = async (limit = 10) => {
  const response = await api.get('/shorts/featured', {
    params: { limit }
  });
  return response.data;
};

// Get shorts by category
export const getShortsByCategory = async (categoryId, page = 1, limit = 10) => {
  const response = await api.get(`/shorts/category/${categoryId}`, {
    params: { page, limit }
  });
  return response.data;
};

// Increment likes count for a short (requires auth)
export const likeShort = async (shortId) => {
  const response = await api.post(`/shorts/${shortId}/like`);
  return response.data;
};

export const unlikeShort = async (shortId) => {
  const response = await api.delete(`/shorts/${shortId}/like`);
  return response.data;
};

// Check if user has liked a short (requires auth)
export const checkUserLike = async (shortId) => {
  const response = await api.get(`/shorts/${shortId}/like/status`);
  return response.data;
};